import type { AuthScope, AuthScopesByLevel } from './types'

export const AUTH_SCOPES = [
  'world:sessions:host',
  'world:tutor-application:submit',
  'world:tutor-application:review',
  'world:channel:description:edit',
  'world:details:edit',
  'world:posts:edit',
  'world:posts:delete',
  'world:posts:pin',
  'world:post_events:create',
  'world:post_events:edit',
  'world:post_events:delete',
  'world:announcements:create',
  'world:posts:react',
  'world:posts:channel:edit',
  'world:post_events:react',
  'world:moderate',
  'world:channel:text_notifications:receive',
  'world:goal:create',
  'world:goal:edit',
  'world:posts:create',
] as const

const MEMBER_AUTH_SCOPES: AuthScope[] = [
  'world:posts:create',
  'world:tutor-application:submit',
  'world:post_events:create',
  'world:posts:react',
  'world:post_events:react',
  'world:goal:create',
  'world:goal:edit',
]

const TUTOR_AUTH_SCOPES: AuthScope[] = [
  ...MEMBER_AUTH_SCOPES,
  'world:sessions:host',
  'world:channel:text_notifications:receive',
]

const MODERATOR_AUTH_SCOPES: AuthScope[] = [
  ...TUTOR_AUTH_SCOPES,
  'world:tutor-application:review',
  'world:channel:description:edit',
  'world:details:edit',
  'world:posts:edit',
  'world:posts:delete',
  'world:posts:channel:edit',
  'world:post_events:edit',
  'world:post_events:delete',
  'world:announcements:create',
  'world:posts:pin',
  'world:moderate',
]

export const LEVEL_TO_AUTH_SCOPES: AuthScopesByLevel = {
  // an array of the true ones
  member: MEMBER_AUTH_SCOPES,
  tutor: TUTOR_AUTH_SCOPES,
  'senior-tutor': TUTOR_AUTH_SCOPES,
  coach: TUTOR_AUTH_SCOPES,
  moderator: MODERATOR_AUTH_SCOPES,
} as const
